import { useCallback, useEffect, useMemo, useState } from 'react'

export const usePagination = <T>(list: T[], pageSize = 10) => {
  const [page, setPage] = useState(0)
  const total = list.length
  const totalPages = Math.ceil(total / pageSize)

  const paginatedList = useMemo(
    () => list.slice(page * pageSize, (page + 1) * pageSize),
    [list, page, pageSize]
  )

  const handlePageChange = useCallback((newPage: number) => {
    setPage(newPage)
  }, [])

  useEffect(() => {
    if (page >= totalPages && totalPages > 0) {
      setPage(totalPages - 1)
    }
  }, [page, totalPages])

  return {
    page,
    totalPages,
    total,
    paginatedList,
    onPageChange: handlePageChange,
  }
}
